import { render, staticRenderFns } from "./authTable.vue?vue&type=template&id=8531c11e&scoped=true"
import script from "./authTable.vue?vue&type=script&lang=ts"
export * from "./authTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8531c11e",
  null
  
)

export default component.exports